import email from "./email/ru";
import reminders from "./reminders/ru";
import settings from './settings/ru';
import program from './program/ru';
import pdfConstructor from "./pdfConstructor/ru";
import pages from './pages/ru';

export default {
    "mainMenu.event": "Трансляция",
    "mainMenu.offline": "Офлайн",
    "mainMenu.tickets": "Билеты",
    "mainMenu.chats": "Чаты",
    "mainMenu.questions": "Вопросы участникам",
    "mainMenu.polls": "Опросы",
    "mainMenu.quizzes": "Квизы",
    "mainMenu.shop": "Магазин призов",
    "mainMenu.eventNotifications": "Сообщения",
    "mainMenu.emails": "Письма",
    "mainMenu.emails.globalSettings": "Общие настройки",
    "mainMenu.emails.password": "Пароль авторизации",
    "mainMenu.emails.eventRegistration": "Подтверждение регистрации",
    "mainMenu.emails.eventAccessAllowed": "Разрешение просмотра",
    "mainMenu.emails.ticket": "Уникальный билет",
    "mainMenu.emails.lettersConstructor": "Шаблоны писем",
    "mainMenu.emails.createLetterTemplate": "Создание шаблона письма",
    "mainMenu.emails.editLetterTemplate": "Изменение шаблона письма",
    "mainMenu.emails.blocksEditor": "Редактор блоков",
    "mainMenu.emails.calendar": "Календарь",
    "mainMenu.reminders": "Рассылка",
    "mainMenu.edit.reminders": "Рассылки",
    "mainMenu.clients": "Зрители",
    "mainMenu.statistic": "Статистика",
    "mainMenu.statistic.visit": "Статистика посещений",
    "mainMenu.statistic.stream.live": "Статистика прямого эфира",
    "mainMenu.statistic.stream.record": "Статистика просмотра записей",
    "mainMenu.statistic.download": "Выгрузки",
    "mainMenu.statistic.shop": "Магазин призов",
    "mainMenu.records": "Записи",
    "mainMenu.pages": "Страницы",
    "mainMenu.pages.edit": "Редактирование страницы",
    "mainMenu.banners": "Баннеры",
    "mainMenu.client_certificate": "Сертификат",
    "mainMenu.client_certificate.settings": "Настройки",
    "mainMenu.client_certificate.owners": "Владельцы",
    "mainMenu.accessByEmails": "Доступ по eMail",
    "mainMenu.accessPreModeration": "Зрители",
    "mainMenu.presenceCheck": "Присутствие",
    "mainMenu.notifications": "Уведомления",
    "mainMenu.activityTop": "Активный участник",
    "mainMenu.widgets": "Виджеты",
    "mainMenu.widget.registration": "Регистрация",
    "mainMenu.widget.registrationConstructor": "Форма регистрации",
    "mainMenu.widget.update": "Изменение настроек виджета",
    "mainMenu.widget.player": "Плеер",
    "mainMenu.widget.platform-player": "Новый плеер",
    "mainMenu.registrations": "Регистрации",
    "mainMenu.eventSettings": "Настройки мероприятия",
    "mainMenu.eventSettings.commonSettings": "Основные настройки",
    "mainMenu.eventSettings.brandingSettings": "Брендинг",
    "mainMenu.eventSettings.authorization": "Авторизация",
    "mainMenu.eventSettings.viewing-restriction": "Ограничение просмотра",
    "mainMenu.eventSettings.loginAndRegistration": "Страница входа и регистрации",
    "mainMenu.eventSettings.playerSettings": "Настройки плеера (old)",
    "mainMenu.eventSettings.enablingModules": "Включение модулей",
    "mainMenu.schedule": "Программа",
    "mainMenu.schedule.episodes": "Редактор эпизодов",
    "mainMenu.schedule.participants": "Участники",
    "mainMenu.schedule.programs": "Конструктор программы",
    "mainMenu.schedule.timetable": "Конструктор расписания",
    "mainMenu.quizConstructor": "Конструктор страницы Квизы",
    "mainMenu.membersConstructor": "Конструктор страницы Участники",
    "mainMenu.broadcastConstructor": "Конструктор страницы Трансляции",
    "mainMenu.defaultConstructor": "Конструктор страницы",
    "mainMenu.lobbyConstructor": "Конструктор страницы Лобби",
    "mainMenu.shopConstructor": "Конструктор страницы Магазин призов",
    "mainMenu.profileConstructor": "Конструктор страницы Профиль участника",
    "mainMenu.hallsConstructor": "Конструктор страницы Залы",
    "mainMenu.hallsSettings": "Настройки залов",
    "mainMenu.pdfConstructor": "Конструктор PDF",
    "mainMenu.interactive": "Интерактив",
    "mainMenu.interactive.pollsAndVoting": "Опросы и голосования в залах",
    "mainMenu.interactive.managePollResult": "Управление результатами",

    "client.ban.button": "Заблокировать",
    "client.unban.button": "Разблокировать",
    "client.ban.confirm": 'Вы действительно хотите заблокировать пользователя "{nickname}"?',
    "client.ban.success": "Пользователь {username} заблокирован",
    "client.unban.confirm": 'Вы действительно хотите разблокировать пользователя "{nickname}"?',
    "client.unban.success": "Пользователь {username} разблокирован",
    "client.ban.modal.title": "Заблокированные пользователи",
    "client.ban.modal.emptyList": "Список пуст",
    "message.control.show": "Показать",
    "message.control.hide": "Скрыть",
    "message.control.delete": "Удалить",
    "message.answer.button": "Ответить",
    "message.submit.button": "Отправить",
    "message.participationType.online": "От онлайн-зрителя",
    "message.participationType.offline": "От зрителя в зале",

    "placeholder.selectValue": "Выбрать значение",

    "role": "Роль",
    "role.viewer": "Зритель",
    "role.moderator": "Модератор",
    "role.organizer": "Организатор",
    "role.speaker": "Спикер",
    "role.technical_support": "Техподдержка",
    "role.change.success": "Роль участника успешно изменена на {value}",

    "status": "Статус",
    "status.approved": "Подтвержден",
    "status.request": "На модерации",
    "status.reject": "Отказано",
    "status.change.success": "Статус участника успешно изменен на {value}",

    "field.change.error": "Произошла ошибка, попробуйте снова",

    participationType: "Формат участия",
    "participationType.online": "Онлайн",
    "participationType.offline": "Офлайн",
    "participationType.hybrid": "Онлайн + Офлайн",

    "participants.clear_question": "Вы уверены, что хотите удалить всех участников?",
    "participants.removeMember": "Вы уверены, что хотите удалить данного участника?",

    "button.create": "Создать",

    "label.poll.answerNumber": "Количество ответов",
    "label.poll.answerColors": "Цветовая схема",

    "poll.type.standard": "Стандартный",
    "poll.type.open": "Облако слов",
    "poll.type.rating": "Рейтинг",

    "quiz.type.standard": "Стандартный",
    "quiz.type.rating": "Рейтинг",
    "quiz.type.open": "Свободный выбор",

    "importExcel.modal.close": "Закрыть",
    "importExcel.modal.confirm": "Подтвердить",
    "importExcel.modal.dontCloseWindow":
        "Не закрывайте это окно до завершения импорта",
    "importExcel.modal.filesAdded": "Добавлено {alreadyAdded} из {total}",
    "importExcel.modal.importError":
        "Произошла ошибка при импорте данных следующих пользователей:",
    "importExcel.modal.loadingIsComplete": "Загрузка завершена",
    "importExcel.modal.next": "Далее",
    "importExcel.modal.table.column": "Столбец",
    "importExcel.modal.table.noColor": "Отсутсвует",
    "importExcel.modal.table.title": "Поле регистрации COMDI",
    "importExcel.modal.table.list": "Лист",
    "importExcel.modal.table.rowNumber": "Номер первой строки",
    "importExcel.modal.title": "Рассылка",
    "importExcel.modal.sendRegistrationLetter":
        "Отправить письмо о регистрации",
    "importExcel.modal.subtitle":
        "Выберите столбец и номер первой строки, содержащие необходимые адреса электронной почты.",

    "episodes.clear_question": "Вы уверены, что хотите удалить все эпизоды?",

    "spectators": "Зрители",

    ...email,
    ...reminders,
    ...settings,
    ...program,
    ...pdfConstructor,
    ...pages,
};
